import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { RouterModule } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ToastService } from "../../../../shared/services/toast.service";
import { CourseModuleService } from "../../../../courseModule/services/courseModule.service";
import { ICourseModule } from "../../../../courseModule/models/courseModule.model";
import { ICourse } from "../../../models/course.model";
import { Store } from "@ngrx/store";
import { getCourseModulesSelector } from "../../../store/course.selectors";
import { getCourse } from "../../../store/course.actions";

@Component({
    selector: 'clp-course-module-list',
    styleUrls: ['./courseModuleList.component.scss'],
    templateUrl: './courseModuleList.component.html',
    imports: [
        RouterModule,
        TranslateModule,
        CommonModule
    ],
    providers: [
        CourseModuleService,
        ToastrService
    ]
})

export class CourseModuleListComponent implements OnInit {
    @Input() courseId!:string | null;
    @Output() courseModuleEditEvent: EventEmitter<ICourseModule> = new EventEmitter<ICourseModule>();

    private courseModuleService = inject(CourseModuleService);
    private store = inject(Store);
    private toastService = inject(ToastService);
    private translate = inject(TranslateService);

    courses$: ICourse[] = [];
    courseModules$!: Observable<ICourseModule[]>;
    courseModules!: ICourseModule[];

    ngOnInit(): void {
      if (this.courseId !== undefined && this.courseId !== null) {
        this.loadModules();
      }
    }

    loadModules(): void {
      if (this.courseId !== undefined && this.courseId !== null) {
        this.courseModules$ = this.store.select(getCourseModulesSelector);
        this.courseModules$.subscribe(modules => {
            this.courseModules = modules;
        });
      }
    }

    editCourseModule(id: string | undefined) {
      if (id === undefined || id === null) {
        return;
      }

      const courseModule = this.courseModules.find(module => module.id === id);
      if (courseModule) {
          this.courseModuleEditEvent?.emit(courseModule);
      }
    }

    deleteCourseModule(id: string | undefined) {
        if (id === undefined || id === null)
            return;

        var return$ = this.courseModuleService.deleteCourseModule(id);

        return$.subscribe(courseModule => {
          if (this.courseId !== undefined && this.courseId !== null) {
            this.store.dispatch(getCourse(this.courseId));
            this.toastService.show(this.translate.instant("courseModule.delete.successMessage"), "");
          }
          // if (courseModule !== undefined && courseModule !== null && courseModule.id !== null) {
          //     if (this.courseId !== undefined && this.courseId !== null) {
          //       this.courseModules$ = this.courseModuleService.getCourseModulesByCourse(this.courseId);
          //     }
          // }
        });
    }
}
